export default function initToggle() {
    const tabGroups = document.querySelectorAll('[data-tabs]');
    tabGroups?.forEach(tabGroup => {
        const tabs = tabGroup.querySelectorAll("[data-toggle-for]");
        tabs?.forEach((tab) => {
            tab.addEventListener("click", () => toggleContent(tab, tabGroup));
        });
    })
}

export function toggleContent(tab, tabGroup) {
    const activeTabClass = tabGroup?.getAttribute('data-active-tab') || 'active';
    const activePanelClass = tabGroup?.getAttribute('data-active-panel') || 'active';
    const activeTabs = tabGroup.querySelectorAll(`.${activeTabClass}`);
    const activePanels = tabGroup.querySelectorAll(`.${activePanelClass}`);

    activeTabs?.forEach(item => item.classList.remove(activeTabClass))
    activePanels?.forEach(item => item.classList.remove(activePanelClass))

    const toggleFor = tab.getAttribute("data-toggle-for");
    tab.classList.toggle(activeTabClass);

    const toggleContent = tabGroup.querySelector(`[data-toggle-content=${toggleFor}]`);
    if (toggleContent) {
        toggleContent.classList.toggle(activePanelClass);
    }
}